import React from "react";

const MenuButton = () => {
    return <button className="navbar-toggler" type="button" data-toggle="collapse"
        data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false"
        aria-label="Toggle navigation">
        <span className="oi oi-menu"></span> Menu</button>
}

export default MenuButton;